<template>
  <div class="table_wrap pb10">
    <div class="el-table list-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table__body-wrapper is-scrolling-none">
      <div class="">
        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">
          <colgroup>
            <col width="">
            <col width="">
            <col width="">
            <col width="">
          </colgroup>
          <thead class="has-gutter">
          <tr>
            <th class="is-leaf list-header">
              <div class="cell">항목</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">고정 게시글</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">수정일</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">옵션</div>
            </th>
          </tr>
          </thead>
          <tbody>
          <ssams-fix-detail-component
              :ssamsType="'ssamsKoreanTalkFix'" :ssamsKey="ssamsKey"
              :boardData="koreanTalk"
          ></ssams-fix-detail-component>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import dateMixins from "@/mixins/dateMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";
import boardValidator from "@/mixins/validators/boardValidator";
import SsamsFixDetailComponent from "@/components/ssams/SsamsFixDetailComponent.vue";


const { filterConfig } = boardFilterUtil;
export default {
  name: "SsamsBoardFixComponent",
  mixins: [
    alertMixins,
    filterMixins,
    listMixins,
    dateMixins,
    boardFilterUtil,
    boardTemplateUtil,
    boardValidator
  ],
  components: {SsamsFixDetailComponent},
  inject: ["changeLoading"],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      boardListSetData: this.setData,
      boardListDelete: this.runDeleteConfirm,
    };
  },

  props: {
    boardType: "",
    userKey: "",
    ssamsKey: "",
  },
  data() {
    return {
      listLayout: "",
      listApiParamSet: {},
      filterLayout: "",
      paginationLayout: "",
      paginationType: "",
      getFunc: "",
      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      keyName: "",
      selectArr: [],
      DeleteClass: null,
      deleteIndex: 0,
      deleteLastIndex: 0,
      filterDate: "",
      filterSort: false,
      content : {},
      koreanTalk : {},
      koreanTalkHasFix : 0,
      contentHasFix : 0,
      parsingData : {}
    };
  },
  created() {
    this.initConfig();
    this.newDeleteClass();
  },
  mounted() {
    EventBus.$on('setSelectOneModalData', this.selectFixData);
  },
  beforeDestroy() {
    EventBus.$off('setSelectOneModalData')
  },
  destroyed() {},
  computed: {},
  methods: {
    initConfig() {
      let ssamsTemplateConfig = this.returnSsamsConfig(this.boardType);
      this.listLayout = ssamsTemplateConfig.listLayout;
      this.filterLayout = ssamsTemplateConfig.filterLayout;
      this.paginationLayout = ssamsTemplateConfig.paginationLayout;
      this.listApiParamSet = ssamsTemplateConfig.listApiParamSet;
      this.paginationType = ssamsTemplateConfig.paginationType;
      this.getFunc = ssamsTemplateConfig.getFunc;
      this.deleteFunc = ssamsTemplateConfig.deleteFunc;
      this.deleteApiParamsSet = ssamsTemplateConfig.deleteApiParamsSet;
      this.deleteSuccessType = ssamsTemplateConfig.deleteSuccessType;
      this.deleteFailTypes = ssamsTemplateConfig.deleteFailTypes;
      this.keyName = ssamsTemplateConfig.keyName;
      this.parsingData = ssamsTemplateConfig.parsingData;
      let listOptions = {
        url: this.$api.$ssams[this.getFunc],
        defaultParams: this.listApiParamSet,
      };

      if (!util.isEmpty(this.ssamsKey)) {
        listOptions.defaultParams.id = this.ssamsKey;
      }

      this.$api.$ssams[this.getFunc](listOptions.defaultParams).then(res => res.Data.Result).then(res=>{
        if(res.Info.type != 1){
          this.createAlert({
            title: '',
            content: '데이터를 불러올 수 없습니다.',
            btnText: '확인',
            hide: () => {
              this.$router.back();
            }
          });
          return;
        }
        this.content = res.List.Content;
        this.koreanTalk = res.List.KoreanTalk;
      });
    },
    setData(key, value) {
      this[key] = value;
    },
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$board[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.keyName,
        errorTypes: this.deleteErrorTypes,
        successType: this.deleteSuccessType,
        afterFunc: this.deleteAfterFunc,
      };
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteConfirm() {
      if (this.selectArr.length === 0) {
        this.errorAlert("목록을 선택해주세요.");
        return false;
      }
      this.createConfirm({
        content: "정말 삭제하시겠습니까?",
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        },
      });
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete();
      } else {
        this.changeLoading(false);
        this.createAlert({
          content: "삭제되었습니다.",
          hide: () => {
            this.getList();
          },
        });
      }
    },

    selectFixData(fixData){
      if(fixData.fixBoardType == 'ssamsContentFix'){
        this.content = fixData.fixBoard
      }else{
        this.koreanTalk = fixData.fixBoard
      }
      EventBus.$emit('chooseItem',fixData);
    },
    checkValidator(dataArr) {
      this.$validate(dataArr)
    },

  },
  watch: {},
};
</script>

<style scoped></style>
